// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"6356c67b","455":"fd0faf4c","977":"138a6b25"}[chunkId] + ".chunk.js";
};